import { STORAGE_KEY } from "../constants";

export const ping = (callback) => {
  return fetchCall({
    url: `${process.env.REACT_APP_SYRUP_SERVER}system/ping`,
    method: "GET",
    callback: callback,
  });
};

export const signIn = (authToken, callback) => {
  return fetchCall({
    url: `${process.env.REACT_APP_SYRUP_SERVER}${process.env.REACT_APP_AUTH}/signin`,
    authRequired: false,
    callback: callback,
    method: "POST",
    body: {
      authToken: authToken,
    },
  });
};

export const signInWithCi = (ci, serviceCode, callback) => {
  return fetchCall({
    url: `${process.env.REACT_APP_SYRUP_SERVER}auth/signin`,
    authRequired: false,
    callback: callback,
    method: "POST",
    body: {
      ci: ci,
      serviceCode: serviceCode,
    },
  });
};

export const signUpHana = (ci, membershipId, callback) => {
  return fetchCall({
    url: `${process.env.REACT_APP_SYRUP_SERVER}cert/hana_start`,
    method: "POST",
    callback: callback,
    body: {
      ci: ci,
      purpose: "SIGNUP_HANA_CARD",
      linkService: "HC",
      membershipId: membershipId,
    },
  });
};

export const leaveMembership = (serviceCode, userKey, memberId, callback) => {
  return fetchCall({
    url: `${process.env.REACT_APP_SYRUP_SERVER}auth/leave`,
    authRequired: false,
    callback: callback,
    method: "POST",
    body: {
      serviceCode: serviceCode,
      userKey: userKey,
      memberId: memberId,
    },
  });
};

export const setOcbPassword = (ocbPassword, callback) => {
  return fetchCall({
    url: `${process.env.REACT_APP_SYRUP_SERVER}${process.env.REACT_APP_AUTH}/ocb`,
    method: "POST",
    callback: callback,
    authRequired: true,
    body: {
      ocbPassword: ocbPassword,
    },
  });
};

export const getCurrentPrice = (callback) => {
  return fetchCall({
    url: `${process.env.REACT_APP_SYRUP_SERVER}price/current`,
    method: "GET",
    callback: callback,
  });
};

export const getOcbPoint = (callback) => {
  return fetchCall({
    url: `${process.env.REACT_APP_SYRUP_SERVER}user/ocbpoint`,
    method: "GET",
    callback: callback,
    authRequired: true,
  });
};

export const getInfo = (callback) => {
  return fetchCall({
    url: `${process.env.REACT_APP_SYRUP_SERVER}user/info`,
    method: "GET",
    callback: callback,
    authRequired: true,
  });
};

export const getProfit = (callback) => {
  return fetchCall({
    url: `${process.env.REACT_APP_SYRUP_SERVER}user/profit`,
    method: "GET",
    callback: callback,
    authRequired: true,
  });
};

export const getBalance = (callback) => {
  return fetchCall({
    url: `${process.env.REACT_APP_SYRUP_SERVER}user/balance`,
    method: "GET",
    authRequired: true,
    callback: callback,
  });
};

export const getPriceTrend = (callback, days) => {
  return fetchCall({
    url: `${process.env.REACT_APP_SYRUP_SERVER}price/trend${
      days ? "?days=" + days : ""
    }`,
    method: "GET",
    callback: callback,
  });
};

export const getHistories = (callback) => {
  return fetchCall({
    url: `${process.env.REACT_APP_SYRUP_SERVER}user/histories`,
    method: "GET",
    callback: callback,
    authRequired: true,
  });
};

export const getPrepareBuy = (token, point, callback) => {
  return fetchCall({
    url: `${process.env.REACT_APP_SYRUP_SERVER}user/prepare_buy`,
    method: "POST",
    callback: callback,
    authRequired: true,
    body: { token, point },
  });
};

export const reqBuyPoint = (prepareBuyId, callback) => {
  return fetchCall({
    url: `${process.env.REACT_APP_SYRUP_SERVER}user/buy`,
    method: "POST",
    callback: callback,
    authRequired: true,
    body: { prepareBuyId },
  });
};

export const authOcb = (ocbPassword, callback) => {
  return fetchCall({
    url: `${process.env.REACT_APP_SYRUP_SERVER}${process.env.REACT_APP_AUTH}/ocb`,
    method: "POST",
    callback: callback,
    authRequired: true,
    body: { ocbPassword },
  });
};

export const getCertificationEncData = (body, callback) => {
  return fetchCall({
    url: `${process.env.REACT_APP_SYRUP_SERVER}cert/hana_start`,
    method: "POST",
    callback: callback,
    body,
  });
};

const fetchCall = ({ url, method, authRequired, body, callback }) => {
  const header = {
    "Content-type": "application/json",
    "Cache-Control": "no-cache",
  };
  if (authRequired) {
    header["Authorization"] = getAccessToken();
  }
  const fetchOptions = {
    method: method,
    headers: header,
  };
  if (body) {
    fetchOptions["body"] = JSON.stringify(body);
  }
  const fetchPromise = fetch(url, fetchOptions)
    .then((response) => response.json())
    .then((response) => {
      callback(response);
    })
    .catch((err) => {
      console.log(err);
      callback({ success: false, message: err.message });
    });
  return fetchPromise;
};

const getAccessToken = () => {
  const accessToken = window.localStorage.getItem(STORAGE_KEY.ACCESS_TOKEN);
  return "Bearer " + accessToken;
};
